import { DialogLayout as h, SequiterButton as P, BUTTON_TYPE as T, DIALOG_VARIANTS as v } from "@ado/acs-standard-library";
import { htmlContentOnly as B } from "../utilities/index.js";
import { getLayout as n, setShowPolicyDialog as C } from "../../../shared/data/layout/state/index.js";
import { defineComponent as S, ref as t, computed as L, customRef as O } from "vue";
import { PolicyDialogOptionsFactory as A } from "../types/index8.js";
import "@ado/acs-standard-library/style.css";
import { useBaseApplicationTranslation as R } from "../../../shared/libraries/local-translations/index.js";
import { createRegionCodeProvider as I } from "@ado/location-library";
const V = S({
  name: "PolicyDialog",
  components: {
    Dialog: h,
    SequiterButton: P
  },
  props: {
    disclaimerSettings: {
      type: Object,
      required: !0
    }
  },
  setup(p) {
    const m = t(T.SUBMIT), i = t("Loading..."), r = t(""), g = t(""), a = t(!0), s = t(!0), d = function() {
      window.print();
    }, l = R(), y = l.isLoaded, c = l.t, f = I().provideRegionCode(), u = L(() => f === "QC" && !n().isQuebecFrench ? "en." : "");
    (async () => {
      const o = A.createPolicyDialogOptions(
        n().policyDialogType,
        p.disclaimerSettings
      ), e = await B(o.link);
      a.value = o.showPrintButton, s.value = o.showSaveButton, r.value = c(
        `${u.value}footer.${o.title}`
      ), i.value = e;
    })();
    const D = O((o, e) => ({
      get() {
        return o(), n().showPolicyDialog;
      },
      set(w) {
        C(w), e();
      }
    }));
    return {
      printDocument: d,
      dialogTitle: r,
      dialogContent: i,
      VARIANTS: v,
      showPolicyDialog: D,
      dialogContentLink: g,
      showSaveButton: s,
      showPrintButton: a,
      dialogBtntype: m,
      t: c,
      areTranslationsLoaded: y,
      footerKeyPrefix: u
    };
  }
});
export {
  V as default
};
//# sourceMappingURL=index24.js.map
